<template>
<div class="chapter">
<div class="inner_page">
<p class="sgc-8"><span class="sgc-7"><br/></span></p>
<p class="sgc-8"><span class="sgc-7">HEIDI</span><br/></p>
<p class="sgc-8" id="id00070">by JOHANNA SPYRI</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main.vue?44f26c98